var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{key:_vm.slotData.name,class:{
    'green--text': _vm.item.type === 'revenue'
  }},[(_vm.item.type === 'revenue')?[_vm._v("-")]:_vm._e(),_vm._v("\n  "+_vm._s(_vm.$number(_vm.item[_vm.slotData.name]))+"\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }